// AI-CONTEXT: See docs/features/arbeidsvaardigheden.md

// Na drie maanden geldt een beoordeling als verouderd. Er is geen vast
// meetmoment: de begeleider bepaalt wanneer hij opnieuw beoordeelt, en dit is
// het signaal dat dat aan de orde is (besluit 2026-08-28).
export const VEROUDERD_NA_MAANDEN = 3

const maandenTussen = (van, tot) =>
    (tot.getFullYear() - van.getFullYear()) * 12 +
    (tot.getMonth() - van.getMonth()) -
    (tot.getDate() < van.getDate() ? 1 : 0)

/**
 * Status van de laatste beoordeling van één deelnemer.
 *
 * `nu` is een parameter en geen `new Date()` in de functie, zodat een test niet
 * van de klok afhangt.
 *
 * @param {Date|null} laatsteBeoordeling
 * @param {Date} [nu]
 * @returns {{status: 'geen'|'actueel'|'verouderd', maandenGeleden: number|null}}
 */
const beoordelingStatus = (laatsteBeoordeling, nu = new Date()) => {
    if (!(laatsteBeoordeling instanceof Date) || Number.isNaN(laatsteBeoordeling.getTime())) {
        return { status: 'geen', maandenGeleden: null }
    }

    // Een beoordeling in de toekomst is geen verouderde beoordeling; die komt uit
    // een verkeerd gezette datum en moet niet als signaal gaan tellen.
    const maandenGeleden = Math.max(0, maandenTussen(laatsteBeoordeling, nu))

    return {
        status: maandenGeleden >= VEROUDERD_NA_MAANDEN ? 'verouderd' : 'actueel',
        maandenGeleden,
    }
}

export default beoordelingStatus
